<template>
  <div>
    <v-row id="page-focus-target">
      <v-col>
        <v-card class="app-card card-borderless" text>
          <v-card-text>
            <v-stepper v-model="stepCounter">
              <v-stepper-header>
                <v-stepper-step :complete="stepCounter > 1" step="1">Select a Service and Domain</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="stepCounter > 2" step="2">Confirmation</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card class="app-card card-borderless">
                    <v-card-text>
                      <form data-vv-scope="step1">
                        <gg-input-label>Select a service</gg-input-label>
                        <v-autocomplete dense
                                        aria-label="Select a service"
                                        class="gg-input"
                                        outlined
                                        :items="servicesList"
                                        name="Service"
                                        item-text="domain"
                                        item-value="id"
                                        v-model="stepOne.service"
                                        v-validate="'required'"
                                        return-object
                                        @change="loadServiceData"
                                        :error-messages="errors.collect('step1.Service')">
                          <template slot="item" slot-scope="{ item }">
                            {{ item.name }}: {{ item.domain }}
                          </template>
                        </v-autocomplete>
                        <template v-if="cpanelsShouldBeLoaded">
                          <gg-input-label>cPanel username</gg-input-label>
                          <v-autocomplete dense
                                          class="gg-input"
                                          aria-label="cPanel username"
                                          :items="stepOne.cpanels"
                                          :loading="stepOne.loadingCpanels"
                                          :disabled="stepOne.loadingCpanels"
                                          outlined
                                          name="Username"
                                          v-validate="'required'"
                                          v-model="stepOne.cpanelusername"
                                          @change="loadDomains"
                                          :error-messages="errors.collect('step1.Username')"></v-autocomplete>
                        </template>
                        <gg-input-label>Select Domain</gg-input-label>
                        <v-autocomplete dense
                                        outlined
                                        class="gg-input"
                                        aria-label="Select Domain"
                                        name="Domain"
                                        :loading="stepOne.loadingDomains"
                                        :disabled="stepOne.loadingDomains"
                                        :items="stepOne.domains"
                                        v-model="stepOne.domain"
                                        v-validate="'required'"
                                        :error-messages="errors.collect('step1.Domain')"></v-autocomplete>
                        <gg-btn color="primary"
                                tile
                                :disabled="stepOneLoading"
                                @click="moveToStep(2, 'step1', true)">
                          Continue
                        </gg-btn>
                      </form>
                    </v-card-text>
                  </v-card>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-card class="app-card card-borderless">
                    <v-card-text>
                      <v-row justify="center">
                        <v-col cols="12" md="10">
                          <v-data-table hide-default-header
                                        hide-default-footer
                                        :headers="providersHeaders"
                                        :items="stepThree.items"
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                              <tr>
                                <th v-for="header in headers"
                                    :key="header.text"
                                    class="text-center pa-4"
                                >
                                  {{ header.text }}
                                  <br v-if="header.chip" />
                                  <v-chip v-if="header.chip" :color="header.chip.color" dark x-small>
                                    {{ header.chip.text }}
                                  </v-chip>
                                  <br/>
                                </th>
                              </tr>
                              </thead>
                            </template>
                            <template v-slot:body="{ items }">
                              <tbody>
                              <tr v-for="item in items" :key="item.name" class="text-center">
                                <td>
                                  <b>{{ item.feature.text }}</b>
                                </td>

                                <td>
                                  <div v-if="item.alphassl.icon">
                                    <div v-if="item.alphassl.icon.withText">
                                      <v-icon :color="item.alphassl.icon.color">
                                        {{ item.alphassl.icon.name }}
                                      </v-icon>
                                      <br>
                                      {{ item.alphassl.text }}
                                    </div>
                                    <div v-else>
                                      <v-icon :color="item.alphassl.icon.color">
                                        {{ item.alphassl.icon.name }}
                                      </v-icon>
                                    </div>
                                  </div>
                                  <span v-else v-html="item.alphassl.text">
                                  </span>
                                </td>

                                <td v-show="leEnabled">
                                  <span v-if="item.le.icon">
                                    <span v-if="item.le.icon.withText">
                                      <v-icon :color="item.le.icon.color">
                                        {{ item.le.icon.name }}
                                      </v-icon>
                                      <br>
                                      {{ item.le.text }}
                                    </span>
                                    <span v-else>
                                      <v-icon :color="item.le.icon.color">
                                        {{ item.le.icon.name }}
                                      </v-icon>
                                    </span>
                                  </span>
                                  <span v-else>
                                    {{ item.le.text }}
                                  </span>
                                  <v-tooltip v-if="item.le.hint" max-width="400" bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-icon class="mb-1" v-on="on" small>mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{ item.le.hint }}</span>
                                  </v-tooltip>
                                </td>
                              </tr>
                              </tbody>
                            </template>
                          </v-data-table>
                        </v-col>
                        <v-col cols="12" class="hidden-sm-and-up">
                          <gg-btn color="primary"
                                  class="mb-2"
                                  tile
                                  v-if="leEnabled"
                                  @click="selectProvider(1)">Select Let's Encrypt
                          </gg-btn>
                          <gg-btn color="primary" tile @click="selectProvider(0)">Buy AlphaSSL</gg-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <v-card class="app-card card-borderless">
                    <v-card-text>
                      <v-row class="ma-2">
                        <v-col cols="12"><hr/></v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <h1 class="mb-4">Payment Information</h1>
                          <p>Please, recheck your selections before submission.</p>
                          <v-alert
                            type="warning"
                            color="primary"
                            class="py-2 mb-4"
                            tabindex="0"
                            role="note"
                            :value="stepThree.provider === 0"
                          >
                            <div class="align-center">
                              You will be charged $49.95 for 1 year, then $99.95/year.
                            </div>
                          </v-alert>
                          <v-alert
                            type="warning"
                            color="primary"
                            class="py-2 mb-4"
                            role="note"
                            :value="stepThree.provider === 1"
                          >
                            <div class="align-center">
                              Read about the
                              <a target='_blank'
                                 href='https://www.greengeeks.com/support/article/lets-encrypt-installation-process/'
                                 style='color:white;font-weight:bold;'>
                                Let's Encrypt Installation Process
                              </a> to confirm your domain is ready.
                            </div>
                          </v-alert>
                        </v-col>
                      </v-row>

                      <v-form data-vv-scope="step3">
                        <gg-input-label>Selected Domain</gg-input-label>
                        <v-combobox dense
                                    outlined
                                    name="Domain"
                                    aria-label="Selected Domain"
                                    disabled
                                    :items="stepOne.domains"
                                    v-model="stepOne.domain"
                                    v-validate="'required'"
                                    :error-messages="errors.collect('step4.Domain')"></v-combobox>
                        <template v-if="cpanelsShouldBeLoaded">
                          <gg-input-label>cPanel Username</gg-input-label>
                          <v-combobox dense
                                      class="gg-input"
                                      aria-label="cPanel Username"
                                      :items="stepOne.cpanels"
                                      :loading="stepOne.loadingCpanels"
                                      disabled
                                      outlined
                                      name="Username"
                                      v-validate="'required'"
                                      v-model="stepOne.cpanelusername"
                                      :error-messages="errors.collect('step1.Username')"></v-combobox>
                        </template>
                        <gg-input-label>SSL Provider</gg-input-label>
                        <v-select dense
                                  outlined
                                  class="gg-input"
                                  aria-label="SSL Provider"
                                  v-model="stepThree.provider"
                                  disabled
                                  item-text="text"
                                  item-value="value"
                                  :items="providersList"></v-select>
                        <template v-if="alphaSslSelected">
                          <certificate-payment v-if="!isAssignedAccessService" ref="cardForm"/>
                          <p>
                            Your order will be reviewed and processed by our Sales team. You will receive an order
                            confirmation number on the next page.
                          </p>
                          <v-alert v-if="isAssignedAccessService" type="error" icon="mdi-alert" class="py-2">
                            You are placing an order for a service you are assigned access to. The account owner will
                            be billed for this SSL certificate.
                          </v-alert>
                        </template>
                        <gg-btn color="primary" tile :loading="loading" @click="submitForm" class="mr-2">
                          Confirm and Create
                        </gg-btn>
                        <gg-btn @click="goBack" secondary depressed tile>Cancel Upgrade</gg-btn>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-stepper-content>
                <v-stepper-content step="3">
                  <v-card>
                    <template v-if="stepFour.error">
                      <v-card-title class="app-card-title pb-0"><h3>Error Adding New SSL</h3></v-card-title>
                      <v-card-text>
                        <p>
                          There was an error with your request. Please try again later or contact Support.
                        </p>
                      </v-card-text>
                    </template>
                    <template v-if="!!stepFour.order_id">
                      <v-card-title class="app-card-title pb-0 mb-3"><h3>SSL Certificate Order Received</h3></v-card-title>
                      <v-card-text>
                        <p>Thank you! Your SSL certificate order has been received and will be processed shortly.</p>
                        <p>Your order number is <b>#{{ stepFour.order_id }}</b></p>
                      </v-card-text>
                    </template>
                    <template v-else-if="!!stepFour.ssl_id">
                      <v-card-title class="app-card-title pb-0">
                        <h3>Let's Encrypt SSL Request Received</h3>
                      </v-card-title>
                      <v-card-text>
                        <p>
                          Thank you! Your Let's Encrypt SSL request has been received and will be processed shortly.
                        </p>
                      </v-card-text>
                    </template>
                    <v-card-actions>
                      <gg-btn :to="{ name: 'ssl_list' }" tile>View Certificates</gg-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <gg-modal :is-active="stepOne.errorModal">
      <template v-slot:toolbar>
        Domain Not Allowed
      </template>
      <template v-slot:body>
        We are not able to issue an AlphaSSL certificate for this domain's TLD. Please contact us if you have any questions.
      </template>
      <template v-slot:actions>
        <gg-btn @click="triggerErrorModal">Close</gg-btn>
      </template>
    </gg-modal>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { resetFocus } from 'oaf-side-effects'
import amapi from '@/api/amapi'
import { makeStepThreeOptions } from '@/consts/create-ssl'
import CertificatePayment from './CertificatePayment'

export default {
  name: 'CreateCertificate',
  components: {
    CertificatePayment
  },
  data () {
    return {
      showGroups: ['Shared Hosting', 'Reseller Hosting'],
      stepCounter: 1,
      loading: false,
      skipSteps: false,
      simplified: {
        cpanelusername: ''
      },
      stepOne: {
        service: '',
        cpanelusername: '',
        cpanels: [],
        loadingDomains: false,
        loadingCpanels: false,
        domain: '',
        domains: [],
        errorModal: false
      },
      stepThree: makeStepThreeOptions(),
      stepFour: {
        resultmsg: '',
        error: false,
      },
    }
  },
  computed: {
    ...mapGetters(['services', 'ssls', 'restrictedSslTlds']),
    cpanelsShouldBeLoaded () {
      if (this.skipSteps) {
        return !!this.simplified.cpanelusername
      }
      return ['Reseller Hosting', 'Virtual Private Server', 'Dedicated Server']
        .indexOf(this.stepOne.service?.groupname) !== -1
    },
    leEnabled () {
      return true
      // return ['Reseller Hosting', 'Shared Hosting'].indexOf(this.stepOne.service?.groupname) !== -1
    },
    providersList () {
      if (!this.leEnabled) {
        return [this.stepThree.providers[0]] // only alphaSSL
      }
      return this.stepThree.providers
    },
    providersHeaders () {
      if (!this.leEnabled) {
        return [this.stepThree.headers[0], this.stepThree.headers[1]] // only alphaSSL
      }
      return this.stepThree.headers
    },
    servicesList () {
      return this.services.filter(service => this.showGroups.indexOf(service.groupname) !== -1)
        .sort((a, b) => {
          if (a.groupname > b.groupname) {
            return 1
          }
          if (a.groupname < b.groupname) {
            return -1
          }
          return 0
        })
    },
    stepOneLoading () {
      return this.stepOne.loadingDomains || this.stepOne.loadingCpanels
    },
    alphaSslSelected () {
      return this.stepThree.provider === 0
    },
    isAssignedAccessService () {
      return this.stepOne.service?.assignedaccess
    },
    isPremiumSSLDomain () {
      if (!this.stepOne.domain) return false
      const ssl = this.ssls.find(ssl => {
        const subdomains = this.stepOne.domain.replace('*', '')
        const domain = this.stepOne.domain.replace('*.', '')
        return ssl.domain == domain || ssl.domain.endsWith(subdomains)
      })
      if (!ssl) return false
      return ssl?.renewalterm !== 'free' // check for LE
    },
    supportLinkQuery () {
      return {
        d: 'Sales',
        s: this.stepOne.service.id,
        sbj: `SSL Purchase: ${this.stepOne.domain}`
      }
    },
    validateDomainTlds () {
      const domain = this.stepOne.domain
      if (!domain) {
        return false
      }

      const domainTlds = Object.values(this.extractDomainParts(domain))

      return domainTlds.some(key => this.restrictedSslTlds.includes(key))
    }
  },
  methods: {
    ...mapActions(['reportError', 'reportSuccess']),
    resetFocus,
    async moveToStep (step, scope = null, validateTld = false) {
      const valid = await this.$validator.validateAll(scope)
      if (!valid) {
        return
      }

      if (validateTld && this.validateDomainTlds) {
        this.triggerErrorModal()

        return
      }

      this.stepCounter = step
    },
    async loadServiceData ({ id }) {
      this.stepOne.domain = ''
      this.stepOne.cpanelusername = ''
      if (this.cpanelsShouldBeLoaded) {
        this.stepOne.loadingCpanels = true
        try {
          const response = await amapi.makecall('ssl_list_cpanels', { hosting_id: id })
          if (response.result === 'success') {
            this.stepOne.cpanels = response.cpanels
            this.stepOne.cpanelusername = response.cpanels[0]
          } else {
            this.reportError(response.resultmsg)
          }
        } catch (e) {
          this.reportError(e)
        }
        this.stepOne.loadingCpanels = false
      }
      // load domains
      await this.loadDomains(this.stepOne.cpanelusername)
    },
    async loadDomains (cpanel_username = '') {
      this.stepOne.loadingDomains = true
      const data = {
        hosting_id: this.stepOne.service.id,
        username: this.$route.query.user
      }
      if (this.cpanelsShouldBeLoaded) {
        data.cpanel_username = cpanel_username
      }
      try {
        const response = await amapi.makecall('ssl_list_domains', data)
        if (response.result === 'success') {
          const queryDomain = this.$route.query.d ? response.domains.find(d => d == this.$route.query.d) : false
          this.stepOne.domain = response.domains.length ? queryDomain || response.domains[0] : ''
          this.stepOne.domains = response.domains
        } else {
          this.reportError(response.resultmsg)
        }
      } catch (e) {
        this.reportError(e)
      }
      this.stepOne.loadingDomains = false
    },
    selectProvider (provider) {
      this.stepThree.provider = provider
      this.stepCounter += 1
    },
    async submitForm () {
      const validForm = await this.$validator.validateAll('step4')
      if (!validForm) return
      this.loading = true
      let data = {
        hosting_id: this.stepOne.service.id,
        ssl_type: this.stepThree.provider,
        ssl_domain: this.stepOne.domain,
        username: this.$route.query.user
      }
      if (this.cpanelsShouldBeLoaded) {
        data.cpanel_username = this.stepOne.cpanelusername
      }
      if (this.alphaSslSelected && !this.isAssignedAccessService) {
        const validCard = await this.$refs.cardForm.validateCard()
        if (!validCard) return
        data = {
          ...data,
          ...this.$refs.cardForm.cardData()
        }
      }
      try {
        const response = await amapi.makecall('ssl_add', data)
        this.stepCounter += 1
        if (response.result === 'success') {
          this.reportSuccess(response.resultmsg)
          if (response.letsencrypt) {
            // Let's Encrypt Redirect
            this.$router.push(`/ssl/${response.id}`)
          }
          // AlphaSSL
          this.stepFour.order_id = response.order_id
        } else {
          this.stepFour.order_id = ''
          this.stepFour.error = true
          this.reportError(response.resultmsg)
        }
      } catch (e) {
        this.reportError(e)
      }
      this.loading = false
    },
    goBack () {
      if (this.skipSteps) {
        return this.$route.name == 'hosting_ssl_create' ? this.$router.go(-1) : this.$router.push({ name: 'ssl_list' })
      }
      this.stepCounter -= 1
    },
    resetSteps () {
      this.stepCounter = 1
      this.stepOne.service = ''
      this.stepOne.cpanelusername = ''
      this.stepOne.domain = ''
      this.stepOne.domains = []
      this.stepThree.provider = ''
      this.stepFour.error = false
      this.stepFour.resultmsg = ''
    },
    extractDomainParts (domain) {
      // eslint-disable-next-line no-useless-escape
      const regex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)(?:[\/:]|$)/i
      const match = domain.match(regex)

      if (match && match[1]) {
        const domainParts = match[1].split('.')
        const tld = domainParts[domainParts.length - 1]
        const sld = domainParts[domainParts.length - 2]

        return {
          tld,
          sld,
        }
      }

      return null
    },
    triggerErrorModal () {
      this.stepOne.errorModal = !this.stepOne.errorModal
    },
    gotoStepThree (serviceId, domain, cpUser) {
      this.skipSteps = true
      this.stepOne.service = { id: serviceId }
      this.simplified.cpanelusername = cpUser
      this.stepOne.cpanels = [cpUser]
      this.stepOne.cpanelusername = cpUser
      this.stepThree.provider = 0 // AlphaSSL
      this.stepOne.domains = [domain]
      this.stepOne.domain = domain
      this.stepCounter = 3
    },
    gotoStepTwo (serviceId, domain, cpUser) {
      this.skipSteps = true
      this.stepOne.service = { id: serviceId }
      this.simplified.cpanelusername = cpUser
      this.stepOne.cpanels = [cpUser]
      this.stepOne.cpanelusername = cpUser
      this.stepThree.provider = 0 // AlphaSSL
      this.stepOne.domains = [domain]
      this.stepOne.domain = domain
      this.stepCounter = 2
    },
  },
  mounted () {
    setTimeout(() => {
      this.resetFocus('#page-focus-target')
    }, 700)
    this.$nextTick(() => {
      if (this.$route.query.s) {
        const service = this.services.find(s => s.id == this.$route.query.s)
        if (service) {
          this.stepOne.service = service
          this.loadServiceData(service)
        }
        return
      }
      // skip to step 3:
      if (this.$route.query.sid && this.$route.query.d) {
        // this.gotoStepThree(this.$route.query.sid, this.$route.query.d, this.$route.query.cp)
        this.gotoStepTwo(this.$route.query.sid, this.$route.query.d, this.$route.query.cp)
      }
    })
  }
}
</script>

<style>
.h-0 {
  height: 0 !important;
}
</style>
